import { useState } from 'react';
import { Link } from 'react-router-dom';
import { featuredMovie } from '@/mocks/movies';
import VideoModal from '@/components/feature/VideoModal';

export default function HeroBanner() {
  const [open, setOpen] = useState(false);
  const movie = featuredMovie;

  return (
    <section className="relative w-full h-[560px] md:h-[680px] overflow-hidden">
      <img
        src={movie.banner}
        alt={`${movie.title} 高清剧照`}
        title={`${movie.title} 在线观看演示`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/70 to-primary-950/20"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-transparent to-primary-950/40"></div>

      <div className="relative w-full h-full px-4 md:px-8 flex items-center">
        <div className="max-w-2xl pt-16 animate-fade-up">
          <div className="flex items-center gap-2 mb-4">
            <span className="px-2.5 py-1 rounded-md text-xs font-semibold bg-accent-500 text-white">
              重点推荐
            </span>
            <span className="px-2.5 py-1 rounded-md text-xs font-medium bg-white/15 text-white backdrop-blur">
              {movie.category} · {movie.year}
            </span>
          </div>

          <h1 className="font-heading font-extrabold text-white text-4xl md:text-6xl leading-tight">
            {movie.title}
          </h1>
          <p className="mt-2 text-white/60 font-heading text-sm md:text-base tracking-widest uppercase">
            {movie.enTitle}
          </p>

          <p className="mt-5 text-white/85 text-sm md:text-base leading-relaxed max-w-xl">
            {movie.summary}
          </p>

          <div className="mt-6 flex items-center flex-wrap gap-3 text-sm text-white/80">
            <span className="flex items-center gap-1.5">
              <i className="ri-star-fill text-accent-400"></i>
              <strong className="text-white">{movie.rating.toFixed(1)}</strong>
            </span>
            <span className="w-px h-4 bg-white/25"></span>
            <span>{movie.duration}</span>
            <span className="w-px h-4 bg-white/25"></span>
            <span>{movie.genres.join(' / ')}</span>
          </div>

          <div className="mt-8 flex items-center flex-wrap gap-3">
            <button
              onClick={() => setOpen(true)}
              className="flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-fill text-lg"></i> 立即播放
            </button>
            <Link
              to={`/detail/${movie.id}`}
              className="flex items-center gap-2 px-6 py-3 rounded-md bg-white/10 text-white font-semibold text-sm border border-white/25 hover:bg-white/20 transition-colors whitespace-nowrap backdrop-blur"
            >
              <i className="ri-information-line text-lg"></i> 剧情详情
            </Link>
          </div>
        </div>
      </div>

      <VideoModal
        open={open}
        title={movie.title}
        poster={movie.cover}
        onClose={() => setOpen(false)}
      />
    </section>
  );
}